import { EventEmitter } from '@angular/core';
import template from './eventDetailPage.html';

export default {
  name: 'eventDetailPageComponent',
  template,
  controller: EventDetailPageController,
  controllerAs: 'EventDetailPageCtrl'
};

/* @ngInject */
function EventDetailPageController($stateParams, EventInfoService, $log, hotkeys, $scope) {

  // ===========================
  // ======Local Variables======
  // ===========================
  const vm = this;
  const eventId = $stateParams.id;
  vm.activeItemChange = new EventEmitter();
  vm.triggerActiveItemChange = triggerActiveItemChange;

  // ===========================
  // ======Local Functions=====
  // ===========================
  EventInfoService.getEvent(eventId)
    .then((success) => {
      vm.event = success.data;
    })
    .catch((err) => {
      $log.error(err);
    });

  function triggerActiveItemChange(_event, hotkey) {
    vm.activeItemChange.emit({
      direction: hotkey.identifier
    });
  }

  // when bind it to the controller's scope, it will automatically unbind
  // the hotkey when the scope is destroyed (due to ng-if or something that changes the DOM)
  hotkeys.bindTo($scope)
    .add({
      combo: ['s'],
      identifier: 'previous',
      description: 'Go to previous thumbnail',
      callback: vm.triggerActiveItemChange
    })
    .add({
      combo: ['d'],
      identifier: 'next',
      description: 'Go to next thumbnail',
      callback: vm.triggerActiveItemChange
    });

}
